import { ReactNode } from 'react';

import { ChakraFlex, FireflyButton, Text } from '@equip.health/ui';

interface DashboardCardEmptyStateProps {
  icon?: ReactNode;
  title: string;
  body: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

const DashboardCardEmptyState = ({
  icon,
  title,
  body,
  ctaLabel,
  onCtaClick,
}: DashboardCardEmptyStateProps) => {
  return (
    <ChakraFlex
      data-testid="dashboard-card-empty-state"
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap="8px"
      padding="24px"
      width="100%"
      height="100%"
    >
      {icon && <ChakraFlex data-testid="empty-state-icon">{icon}</ChakraFlex>}
      <ChakraFlex
        direction="column"
        alignItems="center"
        gap="8px"
        maxWidth="480px"
        textAlign="center"
      >
        <Text variant="h5" color="neutral.secondary">
          {title}
        </Text>
        <Text variant="caption" color="neutral.secondary">
          {body}
        </Text>
      </ChakraFlex>
      {ctaLabel && onCtaClick && (
        <FireflyButton
          data-testid="empty-state-cta"
          id={`empty-state-cta-${title.toLowerCase().replace(/\s+/g, '-')}`}
          variant="secondary"
          size="small"
          onClick={onCtaClick}
        >
          {ctaLabel}
        </FireflyButton>
      )}
    </ChakraFlex>
  );
};

export default DashboardCardEmptyState;
